export default __webpack_public_path__ + "locales/pt/EmptyView.json?hash=89237a60a61fb1d284d2a486e352035c";